import Vue from 'vue';

Vue.component('ingredient-index', () =>
    import(/* webpackChunkName: 'index' */ './ingredient-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory-fnb/ingredient/index.js